module.exports = __webpack_public_path__ + "static/media/air_pollution.81e8db34.png";